import type { ClosePositionConfirmOptions } from "./ClosePositionDialog.controller";
import { useClosePositionDialogController } from "./ClosePositionDialog.controller";
import { ClosePositionDialogPresentation } from "./ClosePositionDialog.pres";
import type { PositionsWidgetRow } from "./PositionsWidget.types";

export interface ClosePositionDialogProps {
  open: boolean;
  positions: PositionsWidgetRow[];
  closeModalRatioPct?: number;
  submitting?: boolean;
  errorMessage?: string;
  onOpenChange: (open: boolean) => void;
  onConfirmClose: (options: ClosePositionConfirmOptions) => void;
}

export const ClosePositionDialog = ({
  open,
  positions,
  closeModalRatioPct,
  submitting,
  errorMessage,
  onOpenChange,
  onConfirmClose,
}: ClosePositionDialogProps) => {
  const controller = useClosePositionDialogController({
    open,
    positions,
    closeModalRatioPct,
    onConfirmClose,
  });

  return (
    <ClosePositionDialogPresentation
      open={open}
      positions={positions}
      submitting={submitting ?? false}
      errorMessage={errorMessage}
      onOpenChange={onOpenChange}
      {...controller}
    />
  );
};
